<template>
  <div :style="`transform:translate(${value.x}px, ${value.y}px);`" :data-x="value.x" :data-y="value.y">
    <md-icon :class="`md-size-05x status${value.status}`">camera_alt</md-icon>
  </div>
</template>
<script>
export default {
  name: 'structure-camera-icon',
  props: ['value']
}
</script>
<style scoped>
.md-size-05x {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  font-size: 30px;
}

.status0 {
  color: #fff;
}

.status1 {
  color: #3ccb70;
}
</style>



// WEBPACK FOOTER //
// StructureCameraIcon.vue?2bc14884